import { css } from "@emotion/react"

export const Box = css`
  display: flex;
  justify-content: center;
  align-items: center;
`
